/**
 * 付与の期限を「10/31」の形にする（Asia/Tokyo）。expires_at は排他の境界なので、その 1 ms 前（最終利用時刻）の日付を
 * 「まで」と表示する（ADR-0044 Decision 6 の「残り n 回（最も近い期限）」）
 */
export function formatCreditExpiry(iso: string): string {
  return new Intl.DateTimeFormat('ja-JP', { timeZone: 'Asia/Tokyo', month: 'numeric', day: 'numeric' }).format(
    new Date(Date.parse(iso) - 1),
  );
}
